import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Form, Button } from 'react-bootstrap';
import CompanyTaskDatatable from '../../CompanyTask/CompanyTaskDatatable';
import ProfileTaskColumns from './ProfileTaskColumns';

const AnnouncementsTasksIndex = () => {
  const history = useHistory();
  const { currentEmployee } = useSelector(state => state.auth);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [customParams, setCustomParams] = useState({
    filter_employee: currentEmployee,
    filter_year: currentYear
  });

  const handleFilter = () => {
    setCustomParams({
      filter_employee: currentEmployee,
      filter_year: year
    });
  };

  useEffect(() => {
    if (currentEmployee) {
      setCustomParams({
        filter_employee: currentEmployee,
        filter_year: currentYear
      });
    }
  }, [currentEmployee, currentYear]);

  const handleShow = item => {
    history.push(`/profile/tasks/${item.id}`);
  };

  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  return (
    <>
      <Row className="m-top mb-3">
        <Col>
          <h2 className="text-uppercase mb-0">Tareas</h2>
        </Col>
      </Row>
      <div className="yellow-wrapper">
        <Card className="mb-4">
          <Card.Body className="p-4">
            <Form
              onSubmit={e => {
                e.preventDefault();
                handleFilter();
              }}
            >
              <Row className="align-items-end">
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Label className="font-weight-bold">
                      Año: <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="select"
                      value={year}
                      onChange={e => setYear(e.target.value)}
                      className="custom-select"
                    >
                      {years.map(y => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} md={{ span: 2, offset: 10 }} className="d-flex align-items-end justify-content-end">
                  <Button type="submit" variant="primary" className="btn-block text-uppercase font-weight-bold mb-3">
                    Filtrar
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {customParams.filter_employee && (
          <CompanyTaskDatatable
            customParams={customParams}
            customColumns={ProfileTaskColumns}
            onShowAction={handleShow}
            withSearch={false}
          />
        )}
      </div>
    </>
  );
};

export default AnnouncementsTasksIndex;
